import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.751 0.784)",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M19.9,6.8L21,5.7c1.2-1.2,1.2-3.1,0-4.3c0,0,0,0,0,0l0,0c-1.1-1.2-2.9-1.3-4.1-0.2c0,0,0,0,0,0 c-0.1,0.1-0.1,0.1-0.2,0.2l-1.1,1.1" }),
			/* @__PURE__ */ _jsx("path", { d: "M11.2,6.9L1.1,17c-1.2,1.1-1.3,2.9-0.2,4.1c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.2,0.2 c1.2,1.2,3.1,1.2,4.2,0l10.1-10.1" }),
			/* @__PURE__ */ _jsx("path", { d: "M13.8,8.6c2.7,2.6,4.9,5.6,6.8,8.8c0.3-0.2,0.6-0.5,0.9-0.8c1.9-1.9,0.6-7.6-3.8-12 S7.5-1,5.7,0.9C5.4,1.2,5.1,1.5,4.9,1.8C8.1,3.7,11.1,6,13.8,8.6z" })
		]
	})
});
export { SvgIconPick as ReactComponent };
